// Store confirmation state since modals don't block execution like window.confirm()
const resolvedAttr = "data-confirm-resolved";

const modalElem = document.getElementById("data-confirm-modal");
const messageElem = document.getElementById("data-confirm-message");

let target = null;

document.body.addEventListener(
  "phoenix.link.click",
  function (e) {
    e.stopPropagation();
    const message = e.target.getAttribute("data-confirm");
    if (!message) {
      return;
    }

    target = e.target;

    if (e.target?.hasAttribute(resolvedAttr)) {
      e.target.removeAttribute(resolvedAttr);
      return;
    }

    e.preventDefault();
    e.target?.setAttribute(resolvedAttr, "");

    const confirmVariant = e.target.dataset.confirmVariant || "danger";
    const buttonElem = document.getElementById(`data-confirm-button-${confirmVariant}`);

    buttonElem.innerHTML = e.target.dataset.confirmButton || "Confirm";
    messageElem.innerHTML = e.target.dataset.confirm;

    ["default", "danger"].forEach((buttonVariant) => {
      const buttonElem = document.getElementById(`data-confirm-button-${buttonVariant}`);
      buttonElem.classList.toggle("hidden", buttonVariant !== confirmVariant);
    });

    window.liveSocket.execJS(modalElem, modalElem.dataset.show);
  },
  false,
);

window.addEventListener("data-confirm:confirm", () => {
  window.liveSocket.execJS(modalElem, modalElem.dataset.hide);
  target?.click();
  target = null;
});

window.addEventListener("data-confirm:cancel", () => {
  window.liveSocket.execJS(modalElem, modalElem.dataset.hide);
  target?.removeAttribute(resolvedAttr);
  target = null;
});
